/* Vinanest editorial landing: behaviour for sections/vinanest-editorial.liquid.
   Both languages are already in the markup (<span class="vi"> / <span class="en">), so the language switch only flips
   html[data-vne-lang]; everything built here is built the same way. Cart = Shopify AJAX API (/cart.js and friends). */
(function () {
  'use strict';
  function boot() {
  var root = document.getElementById('vne'), dataEl = document.getElementById('vne-data');
  if (!root || !dataEl || root.getAttribute('data-vne-ready')) return;
  root.setAttribute('data-vne-ready', '1');
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var W = window, H = document.documentElement, B = document.body;
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || D.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var PRODUCTS = D.products || [], BY = {}, BYVID = {};
  PRODUCTS.forEach(function (p) {
    BY[p.key] = p;
    BYVID[p.vid] = { p: p, big: false };
    if (p.large) BYVID[p.large.vid] = { p: p, big: true };
  });
  /* product page (sections/vinanest-editorial-product.liquid): this product's data; null on the home page */
  var PD = D.pdp && root.querySelector('[data-vne-pdp]') ? D.pdp : null;
  var P = { qty: 1, gal: 0, z: false }, swiped = 0;
  var REDUCE = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var FINE = !!(W.matchMedia && W.matchMedia('(hover: hover) and (pointer: fine)').matches), cardSwipeAt = 0;   /* mouse vs touch; last card-photo swipe */
  var IOS = /iPhone|iPad|iPod/.test(navigator.userAgent || '') || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var GROUP = { gift: ['Để biếu tặng', 'To give as a gift', 'Hợp biếu', 'For gifting'], daily: ['Dùng hằng ngày', 'For every day', 'Dùng hằng ngày', 'Everyday'], best: ['Loại cao cấp nhất', 'Our top grade', 'Cao cấp', 'Premium'] };
  /* captions for the 13.4 s workshop clip: [start second, Vietnamese, English] */
  var CUES = [[0, 'Nhặt từng sợi lông bằng tay tại xưởng', 'Feathers picked out by hand in our workshop'], [5, 'Hút chân không, đóng gói', 'Vacuum-sealed and packed'], [9, 'Yến sạch, sẵn sàng giao đi', 'Clean nest, ready to ship']];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var ICON = {
    check: '<path d="M4.8 12.6 9.3 17 19.2 7.2"/>',
    truck: '<path d="M2.8 6.2h11.4v9.6H2.8z"/><path d="M14.2 9.4h3.9l3.1 3.4v3h-7"/><circle cx="7" cy="17.4" r="1.9"/><circle cx="17.2" cy="17.4" r="1.9"/>',
    gift: '<path d="M4.5 10.5h15V20h-15z"/><path d="M3.5 7.2h17v3.3h-17zM12 7.2V20"/><path d="M12 7.2C10.6 4.4 7.2 3.9 7.2 6c0 1.2 2.4 1.2 4.8 1.2zM12 7.2c1.4-2.8 4.8-3.3 4.8-1.2 0 1.2-2.4 1.2-4.8 1.2z"/>',
    refund: '<path d="M4.6 13.2a7.6 7.6 0 1 0 2.2-6.4"/><path d="M4.4 3.8v3.9h3.9"/><path d="M12 8.2v7.6M14.2 9.8c-.4-.8-1.2-1.2-2.2-1.2-1.3 0-2.2.7-2.2 1.7 0 2.4 4.6 1.2 4.6 3.6 0 1-1 1.8-2.4 1.8-1.1 0-1.9-.5-2.3-1.3"/>',
    pin: '<path d="M12 21s-6.5-5.7-6.5-11.2a6.5 6.5 0 0 1 13 0C18.5 15.3 12 21 12 21z"/><circle cx="12" cy="9.8" r="2.3"/>'
  };

  /* ---------- helpers ---------- */
  function q(s, el) { return (el || root).querySelector(s); }
  function qa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function bi(vi, en) { return '<span class="vi">' + esc(vi) + '</span><span class="en">' + esc(en || vi) + '</span>'; }
  function biP(pair) { return pair ? bi(pair[0], pair[1]) : ''; }
  function isEn() { return H.getAttribute('data-vne-lang') === 'en'; }
  function ico(name) { return '<svg class="vne-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICON[name] + '</svg>'; }
  function label(el, vi, en) { el.setAttribute('data-vi-label', vi); el.setAttribute('data-en-label', en || vi); el.setAttribute('aria-label', isEn() ? (en || vi) : vi); }
  function visible(el) { return !!(el && el.getClientRects().length); }
  function save(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function track(name, data) {
    try { (W.dataLayer = W.dataLayer || []).push(Object.assign({ event: 'vn_' + name }, data || {})); } catch (e) {}
    try { if (W.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('vn_' + name, data || {}); } catch (e) {}   /* visible to Customer events pixels */
  }
  function mImg(u) { return String(u).replace(/(\.jpg)(\?|$)/, '-m$1$2'); }   /* 600px copy of a packshot (vne-p-KEY-m.jpg) */
  /* std = a standard event Shopify's own pixel already sends (add-to-cart, checkout start, product page view): only when Theme settings say so */
  function pixel(ev, data, std) { if (std && !W.VNE_PIXEL_STD) return; try { if (W.fbq && W.VNE_PIXEL) W.fbq('trackSingle', W.VNE_PIXEL, ev, data || {}); } catch (e) {} }
  function zoom() { return [1, 1.15, 1.3][+(H.getAttribute('data-vne-size') || 0)] || 1; }
  function nb(s) { return String(s).replace(/ /g, ' ').replace(/–/g, '⁠–⁠'); }
  function money(cents) {
    var v = (Math.round(+cents || 0)) / 100;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: D.currency || 'USD' }).format(v); } catch (e) { return '$' + v.toFixed(2); }
  }
  function oz(g) { var v = Math.round(g / 28.3495 * 10) / 10; return (v % 1 === 0 ? String(v) : v.toFixed(1)) + ' oz'; }
  function scrollToEl(el, off) { if (el) W.scrollTo({ top: el.getBoundingClientRect().top + W.scrollY - (off || 0), behavior: REDUCE ? 'auto' : 'smooth' }); }

  /* Pacific time: phone hours, the "open now" dot and delivery estimates follow California. */
  function pacific() {
    var d = new Date();
    try {
      var g = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23', weekday: 'short' })
        .formatToParts(d).forEach(function (x) { g[x.type] = x.value; });
      return { y: +g.year, mo: +g.month, d: +g.day, m: (+g.hour % 24) * 60 + +g.minute, wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(g.weekday) };
    } catch (e) { return { y: d.getFullYear(), mo: d.getMonth() + 1, d: d.getDate(), m: d.getHours() * 60 + d.getMinutes(), wd: d.getDay() }; }
  }
  /* Orders placed on a weekday before noon ship the same day; delivery = D.shipDays business days after shipping. */
  function eta() {
    var n = pacific(), span = String(D.shipDays || '').split(/[–-]/).map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; });
    if (!span.length) return null;
    var shift = n.wd >= 1 && n.wd <= 5 && n.m < 720 ? 0 : 1;
    function add(k) { var t = new Date(Date.UTC(n.y, n.mo - 1, n.d, 12)), c = 0; while (c < k) { t.setUTCDate(t.getUTCDate() + 1); var w = t.getUTCDay(); if (w !== 0 && w !== 6) c++; } return t; }
    var a = add(span[0] + shift), b = add((span[1] || span[0]) + shift), am = a.getUTCMonth(), bm = b.getUTCMonth();
    if (a.getTime() === b.getTime()) return [a.getUTCDate() + '/' + (am + 1), MON[am] + ' ' + a.getUTCDate()];
    if (am === bm) return [a.getUTCDate() + '–' + b.getUTCDate() + '/' + (am + 1), MON[am] + ' ' + a.getUTCDate() + '–' + b.getUTCDate()];
    return [a.getUTCDate() + '/' + (am + 1) + ' – ' + b.getUTCDate() + '/' + (bm + 1), MON[am] + ' ' + a.getUTCDate() + ' – ' + MON[bm] + ' ' + b.getUTCDate()];
  }
  function hourVi(h) { return h + ':00'; }
  function hourEn(h) { return h === 0 ? '12am' : h < 12 ? h + 'am' : h === 12 ? '12pm' : (h - 12) + 'pm'; }
  function openNow() { if (!D.hoursOn) return { open: true, early: false };   /* hours not confirmed by the owner: never say closed */
    var n = pacific(); return { open: n.m >= D.hoursOpen * 60 && n.m < D.hoursClose * 60, early: n.m < D.hoursOpen * 60 }; }

  /* ---------- language + text size ---------- */
  function relabel() {
    var en = isEn(), k = en ? 'data-en-label' : 'data-vi-label', kp = en ? 'data-en-ph' : 'data-vi-ph';
    qa('[data-vi-label]').forEach(function (el) { var v = el.getAttribute(k); if (v == null) return; if (el.tagName === 'IMG') el.setAttribute('alt', v); else el.setAttribute('aria-label', v); });
    qa('[data-vi-ph]').forEach(function (el) { var v = el.getAttribute(kp); if (v != null) el.setAttribute('placeholder', v); });
  }
  function syncToggles() {
    var l = isEn() ? 'en' : 'vi', z = H.getAttribute('data-vne-size') || '0';
    qa('button[data-vne-lang]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-vne-lang') === l)); });
    qa('button[data-vne-size]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-vne-size') === z)); });
    H.lang = l;
    W.currentLang = l;
  }
  function compact() { var v = W.innerHeight / zoom(); H.classList.toggle('vne-compact', v < 720); H.classList.toggle('vne-tight', v < 880); }
  function refit() { requestAnimationFrame(function () { if (W.vneFitHero) W.vneFitHero(); checkBar(); }); }
  function setLang(l) {
    H.setAttribute('data-vne-lang', l);
    save('vinanest_lang', l);
    syncToggles(); relabel(); refit();
    track('language', { lang: l });
  }
  function setSize(z) {
    H.setAttribute('data-vne-size', z);
    save('vn_size', z);
    syncToggles(); compact(); refit();
    track('text_size', { size: +z });
  }

  /* ---------- ad openings + grid filter ---------- */
  var ANGLE = H.getAttribute('data-vne-for') || 'default';
  var filter = 'all';
  function setFilter(k, scroll) {
    filter = k;
    var n = 0;
    qa('[data-vne-tile]').forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-vne-tile') === k)); });
    qa('[data-vne-card]').forEach(function (c) {
      var show = k === 'all' || (' ' + (c.getAttribute('data-groups') || '') + ' ').indexOf(' ' + k + ' ') > -1;
      c.hidden = !show;
      if (show) n++;
    });
    var lab = q('[data-vne-gridlabel]'), all = q('[data-vne-seeall]');
    if (lab) lab.innerHTML = k === 'all' || !GROUP[k]
      ? bi('Tất cả ' + D.count + ' loại · bán chạy nhất trước', 'All ' + D.count + ' kinds · best sellers first')
      : bi('Đang xem: ' + GROUP[k][0] + ' · ' + n + ' loại', 'Showing: ' + GROUP[k][1] + ' · ' + n + ' kinds');
    if (all) all.hidden = k === 'all';
    giftCards(k === 'gift');
    if (scroll) requestAnimationFrame(function () { scrollToEl(q('[data-vne-gridhead]'), 16); });
  }
  /* Gift view: a nest that comes in the red 227g gift box shows that box (photo, size, price, add button, photos on hover),
     and the gifts are sorted by price; every other view shows the 100g box again. */
  function giftCards(on) {
    qa('[data-vne-card]').forEach(function (c) {
      var p = BY[c.getAttribute('data-vne-card')];
      if (!p) return;
      var big = !!(on && p.large && p.large.avail), was = c.getAttribute('data-vne-big') === '1';
      c.style.order = on ? String(Math.round((big ? p.large.price : p.price) / 100)) : '';
      if (big === was) return;
      var img = q('.vne-card-pic', c), size = q('.vne-card-size', c), size2 = q('.vne-card-size2', c), pr = q('.vne-add-r b', c);
      if (!c._orig) c._orig = { img: img && img.getAttribute('src'), set: img && img.getAttribute('srcset'), size: size && size.innerHTML, size2: size2 && size2.innerHTML, pr: pr && pr.textContent };
      if (big) {
        c.setAttribute('data-vne-big', '1');
        if (img && p.large.img) { img.setAttribute('srcset', mImg(p.large.img) + ' 600w, ' + p.large.img + ' 1000w'); img.setAttribute('src', mImg(p.large.img)); }
        if (size) size.innerHTML = bi('Hộp quà 227g · khoảng ' + p.large.bowls + ' chén', '227g gift box · about ' + p.large.bowls + ' bowls');
        if (size2) size2.innerHTML = bi('Hộp 100g: ' + money(p.price), '100g box: ' + money(p.price));
        if (pr) pr.textContent = money(p.large.price);
      } else {
        c.removeAttribute('data-vne-big');
        if (img) { img.setAttribute('srcset', c._orig.set); img.setAttribute('src', c._orig.img); }
        if (size) size.innerHTML = c._orig.size;
        if (size2) size2.innerHTML = c._orig.size2;
        if (pr) pr.textContent = c._orig.pr;
      }
      if (c._g && c._g.wrap) c._g.wrap.remove();
      c._g = null;   /* hover photos follow the box shown */
      if (!FINE) cardGal(c, true);
    });
  }
  function heroCta() { var v = null; qa('[data-vne-herocta]').forEach(function (b) { if (visible(b)) v = b; }); return v; }
  function heroGo(btn) {
    var b = btn || heroCta();
    track('hero_cta', { angle: ANGLE });
    if (b && b.getAttribute('data-vne-open')) { openSheet(b.getAttribute('data-vne-open'), 'hero'); return; }
    if (b && b.getAttribute('data-vne-filter')) { setFilter(b.getAttribute('data-vne-filter'), true); return; }
    var coll = document.getElementById('collection');
    if (!coll) { W.location.href = ROOT + '#collection'; return; }   /* pages without the product grid: the home page's */
    scrollToEl(coll, 0);
  }

  /* ---------- sticky bar + chat button ---------- */
  var bar = q('[data-vne-bar]'), raf = 0;
  /* while the sticky bar is up, links and focus scroll their target clear of it */
  function barUp(on) { B.classList.toggle('vne-bar-up', on); H.style.scrollPaddingBottom = on ? (bar.offsetHeight + 12) + 'px' : ''; }
  function checkBar() {
    raf = 0;
    if (!bar) return;
    if (PD) {
      /* product page: the bar stands in for the main button whenever that button is off screen */
      var pb = q('[data-vne-pbuy]'), pr = pb && pb.getBoundingClientRect(), on = !openKind() && (!pr || pr.bottom < 0 || pr.top > W.innerHeight);
      bar.classList.toggle('vne-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      barUp(on);
      B.classList.remove('vne-at-top');
      return;
    }
    if (root.classList.contains('vne-site')) {
      /* contact, policies, collections, search…: the bar is only a way back to the order */
      var sOn = !openKind() && count() > 0;
      bar.classList.toggle('vne-on', sOn);
      bar.setAttribute('aria-hidden', String(!sOn));
      barUp(sOn);
      return;
    }
    var vh = W.innerHeight, cta = heroCta(), grid = document.getElementById('collection') || q('[data-vne-grid]'), hero = document.getElementById('top');
    var out = true, gridIn = false;
    if (cta) { var r = cta.getBoundingClientRect(); out = r.bottom < 0 || r.bottom > vh; }
    if (grid) { var g = grid.getBoundingClientRect(); gridIn = g.top < vh - 1 && g.bottom > vh * 0.3; }
    /* one button: "View order" once something is in the cart; otherwise the hero's action, kept out of the way while the product cards (each with its own button) are on screen */
    var n = count(), show = !openKind() && (n > 0 || (out && !gridIn));
    bar.classList.toggle('vne-on', show);
    bar.setAttribute('aria-hidden', String(!show));
    barUp(show);
    B.classList.toggle('vne-at-top', !!hero && hero.getBoundingClientRect().bottom > vh * 0.5);
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(checkBar); }
  function paintBar() {
    if (!bar) return;
    var l = q('[data-vne-barl]', bar), s = q('[data-vne-bars]', bar), n = count();
    if (PD) {
      var tot = money(PD.key ? qtyPrice(PD.price, P.qty, boxCount()).tot : PD.price * P.qty);   /* same number as the buy button */
      if (inCart(PD.vid)) { l.innerHTML = bi('Xem đơn hàng', 'View order'); s.hidden = false; s.textContent = money(cart.total_price); }
      else if (PD.avail) { l.innerHTML = bi('Mua ngay →', 'Buy now →'); s.hidden = false; s.innerHTML = P.qty > 1 ? bi((P.qty + ' ' + PD.unit[0]).trim() + ' · ' + tot, (P.qty + ' ' + PD.unit[2]).trim() + ' · ' + tot) : esc(tot); }
      else { l.innerHTML = bi('Hết hàng · Gọi ' + D.phone, 'Sold out · Call ' + D.phone); s.hidden = true; }
      return;
    }
    if (n > 0) {
      l.innerHTML = bi('Xem đơn hàng', 'View order');
      s.hidden = false;
      s.textContent = money(cart.total_price);
    } else {
      var c = heroCta(), vi = c && q('.vi', c), en = c && q('.en', c);
      l.innerHTML = c && c.getAttribute('data-vne-open') ? bi('Mua ngay →', 'Buy now →') : bi((vi ? vi.textContent : 'Chọn hộp yến') + ' →', (en ? en.textContent : 'Choose your box') + ' →');
      s.hidden = true;
    }
  }

  /* ---------- dialogs (sheet, drawer, lab) ---------- */
  var sheetRoot = q('[data-vne-sheetroot]'), drawerRoot = q('[data-vne-drawerroot]'), menuRoot = q('[data-vne-menuroot]'), lab = q('[data-vne-lab]');
  var zoomEl = q('[data-vne-zoom]');
  var page = q('.vne-zz'), lastFocus = null, pinnedAt = 0;
  function openKind() {
    if (zoomEl && zoomEl.classList.contains('vne-on')) return 'zoom';
    if (lab && lab.classList.contains('vne-on')) return 'lab';
    if (drawerRoot && drawerRoot.classList.contains('vne-on')) return 'drawer';
    if (menuRoot && menuRoot.classList.contains('vne-on')) return 'menu';
    if (sheetRoot && sheetRoot.classList.contains('vne-on')) return 'sheet';
    return '';
  }
  function dialogEl(kind) { return kind === 'zoom' ? zoomEl : kind === 'lab' ? lab : kind === 'drawer' ? q('[data-vne-drawer]') : kind === 'menu' ? q('[data-vne-menu]') : kind === 'sheet' ? q('[data-vne-sheet]') : null; }
  function lock() {
    var k = openKind();
    B.classList.toggle('vne-lock', !!k);
    if (page) { if (k) page.setAttribute('inert', ''); else page.removeAttribute('inert'); }
    checkBar();
  }
  function pin(el) { if (el) { lastFocus = el; pinnedAt = Date.now(); } }   /* a named way back beats whatever still holds focus when the dialog opens */
  function remember() { if (lastFocus && Date.now() - pinnedAt < 10000) return; var a = document.activeElement; if (a && a !== B && !(a.closest && a.closest('[data-vne-sheet],[data-vne-drawer],[data-vne-menu],[data-vne-lab],[data-vne-zoom]'))) lastFocus = a; }
  function restore() { var el = lastFocus; lastFocus = null; pinnedAt = 0; if (el && el.isConnected && !openKind()) requestAnimationFrame(function () { try { el.focus({ preventScroll: true }); } catch (e) {} }); }
  function focusIn(sel) { requestAnimationFrame(function () { var b = q(sel); if (b) try { b.focus({ preventScroll: true }); } catch (e) {} }); }
  function trap(e) {
    var d = dialogEl(openKind());
    if (!d) return;
    var f = qa('a[href],button:not([disabled]),input:not([type="hidden"]),textarea,select,video[controls],[tabindex]:not([tabindex="-1"])', d).filter(visible);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!d.contains(a)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- product sheet ---------- */
  var S = { key: null, big: false, qty: 1, gal: 0 };
  function variantOf(p, big) {
    var L = big && p.large ? p.large : null;
    /* photos follow the size: the 227g gift box has its own packshot, infographic, serving photo and label */
    return L
      ? { vid: L.vid, price: L.price, avail: L.avail, url: L.url, bowls: L.bowls, grams: L.grams, size: L.size, img: L.img || p.img, info: L.info || null, scene: L.scene || null, sceneM: L.sceneM || null, label: L.label || null }
      : { vid: p.vid, price: p.price, avail: p.avail, url: p.url, bowls: p.bowls, grams: p.grams, size: p.size, img: p.img, info: p.info || null, scene: p.scene || null, sceneM: p.sceneM || null, label: p.label || null };
  }
  function perText(p, v) {
    var each = money(v.price / Math.max(1, v.bowls));
    return p.jars ? bi('≈ ' + each + ' mỗi hũ', '≈ ' + each + ' per jar') : bi('≈ ' + each + ' mỗi chén', '≈ ' + each + ' per bowl');
  }
  /* delivery date, free gift, refund and origin lines (product sheet + product page) */
  function factsHtml(noGift, withOrigin, price, handle) {
    var facts = [], e = eta(), small = !D.smallShip && D.shipMin && price > 0 && price < D.shipMin;
    if (D.freeShip && small) facts.push(['truck', 'Chỉ giao cùng đơn từ ' + money(D.shipMin) + ', ví dụ kèm một hộp yến', 'Ships only with orders of ' + money(D.shipMin) + ' or more, e.g. with a nest box']);
    else if (D.freeShip) facts.push(['truck', e ? 'Giao miễn phí · nhận khoảng ' + nb(e[0]) : 'Miễn phí giao hàng', e ? 'Free delivery · arrives about ' + nb(e[1]) : 'Free delivery']);
    if (D.freeGift && !noGift) facts.push(['gift', 'Tặng kèm táo đỏ & đường phèn', 'Free red dates & rock sugar']);
    if (D.freeGift && /sugar-candy|dried-jujube-tao/.test(handle || '')) facts.push(['gift', 'Đã tặng kèm miễn phí theo mỗi hộp yến', 'Already free with every nest box']);
    facts.push(['refund', 'Hoàn tiền 100% trong ' + D.refundDays + ' ngày' + (D.refundOpened ? ', kể cả khi đã mở hộp' : ''), '100% refund within ' + D.refundDays + ' days' + (D.refundOpened ? ', even if opened' : '')]);
    if (withOrigin && D.origin) facts.push(['pin', 'Từ nhà yến của gia đình tại ' + D.origin + ', Việt Nam', 'From our family swiftlet houses in ' + D.origin + ', Vietnam']);
    return facts.map(function (f) { return '<li>' + ico(f[0]) + '<span>' + bi(f[1], f[2]) + '</span></li>'; }).join('');
  }
  function inCart(vid) { return !!(cart && (cart.items || []).some(function (it) { return it.variant_id === vid && it.quantity > 0; })); }
  function openSheet(key, via, gal, big) {
    var p = BY[key];
    if (!p || !sheetRoot) return;
    remember();
    S.key = key; S.big = !!(big && p.large && p.large.avail); S.qty = 1; S.gal = gal || 0;
    if (!p.avail && p.large && p.large.avail) { S.big = true; S.gal = 0; }
    renderSheet();
    sheetRoot.classList.add('vne-on');
    var body = q('[data-vne-sheetbody]'); if (body) body.scrollTop = 0;
    lock();
    focusIn('[data-vne-sheetx]');
    track('product_open', { id: key, via: via || 'card' });
    pixel('ViewContent', { content_ids: [String(p.vid)], content_type: 'product', value: p.price / 100, currency: D.currency });
  }
  function closeSheet(keepFocus) {
    if (!sheetRoot || !sheetRoot.classList.contains('vne-on')) return;
    sheetRoot.classList.remove('vne-on');
    lock();
    if (!keepFocus) restore();
  }
  var seenImg = {};
  function renderSheet() {
    var p = BY[S.key];
    if (!p) return;
    var v = variantOf(p, S.big), has = inCart(v.vid);
    /* the same photos as the product page and the Shopify listing: box, infographic, serving photo, nutrition label */
    var gal = [{ img: v.img, l: p.name, mult: true }];
    if (v.info) gal.push({ img: v.info[1], th: v.info[2], fit: true, l: ['Điểm nổi bật', 'At a glance'] });
    // serving photo: the product's own box at the back, the nest cooked in front (whole square, never cropped)
    if (v.scene) gal.push({ img: v.scene[0], th: v.scene[1], scene: true, cap: true, l: p.jars ? ['Gợi ý thưởng thức', 'Serving suggestion'] : ['Gợi ý cách dùng: chưng cách thủy', 'Serving suggestion: double-boiled'] });
    if (v.label) gal.push({ img: v.label[1], th: v.label[2], fit: true, l: ['Bảng dinh dưỡng', 'Nutrition Facts'] });
    gal.forEach(function (x) { if (!seenImg[x.img]) { seenImg[x.img] = 1; var im = new Image(); im.decoding = 'async'; im.src = x.img; } });   /* every photo ready before its thumb is tapped */
    var g = gal[S.gal] || gal[0], main = q('[data-vne-galmain]'), cap = q('[data-vne-galcap]');
    main.style.backgroundImage = 'url("' + g.img + '")';
    main.classList.toggle('vne-cover', !g.mult && !g.scene && !g.fit);
    main.classList.toggle('vne-scene', !!(g.scene || g.fit));
    label(main, g.l[0], g.l[1]);
    if (cap) cap.innerHTML = g.cap ? biP(g.l) : '';
    var thumbs = q('[data-vne-thumbs]');
    thumbs.hidden = gal.length < 2;
    thumbs.innerHTML = gal.map(function (x, i) {
      return '<button type="button" class="vne-thumb' + (x.mult ? ' vne-mult' : '') + '" data-vne-gal="' + i + '" aria-pressed="' + (S.gal === i) + '" style="background-image:url(&quot;' + esc(x.th || x.img) + '&quot;)" aria-label="' + esc(isEn() ? x.l[1] : x.l[0]) + '" data-vi-label="' + esc(x.l[0]) + '" data-en-label="' + esc(x.l[1]) + '"></button>';
    }).join('');
    var badge = q('[data-vne-sbadge]');
    badge.innerHTML = p.badge[0] ? biP(p.badge) : '';
    badge.hidden = !p.badge[0];
    q('[data-vne-sname]').innerHTML = biP(p.name);
    q('[data-vne-ssize]').innerHTML = p.jars ? biP(v.size) : bi(v.size[0] + ' · khoảng ' + v.bowls + ' chén', v.size[1] + ' · about ' + v.bowls + ' bowls');
    q('[data-vne-sprice]').textContent = money(v.price);
    q('[data-vne-sper]').innerHTML = perText(p, v);
    var sizes = q('[data-vne-ssizes]');
    sizes.hidden = !p.large;
    if (p.large) {
      q('[data-vne-ssizeopts]').innerHTML = [false, true].map(function (big) {
        var x = variantOf(p, big), on = S.big === big;
        return '<button type="button" class="vne-opt" data-vne-pick-size="' + (big ? 1 : 0) + '" aria-pressed="' + on + '"' + (x.avail ? '' : ' disabled') + '><b>' + (big ? bi('Hộp quà ' + x.grams + 'g', x.grams + 'g gift box') : bi('Hộp ' + x.grams + 'g', x.grams + 'g box')) + '</b><small>' + (x.avail ? esc(oz(x.grams) + ' · ' + money(x.price)) + '<span class="vne-per">' + bi('≈ ' + money(x.price / Math.max(1, x.bowls)) + '/chén', '≈ ' + money(x.price / Math.max(1, x.bowls)) + '/bowl') + '</span>' : bi('Hết hàng', 'Sold out')) + '</small></button>';
      }).join('');
    }
    var qtys = q('[data-vne-sqtys]');
    qtys.hidden = has || !v.avail;
    var others = boxCount();
    q('[data-vne-sqtyopts]').innerHTML = (BUNDLE ? [1, 2, 3] : [1, 2]).map(function (n) {
      var lv = p.jars ? n + ' set' : n + ' hộp', le = p.jars ? n + (n > 1 ? ' sets' : ' set') : n + (n > 1 ? ' boxes' : ' box');
      return '<button type="button" class="vne-opt" data-vne-qty="' + n + '" aria-pressed="' + (S.qty === n) + '"><b>' + bi(lv, le) + '</b><small>' + qtyPrice(v.price, n, others).html + '</small></button>';
    }).join('');
    q('[data-vne-sdesc]').innerHTML = biP(p.desc);
    q('[data-vne-sfacts]').innerHTML = factsHtml(p.jars, p.key !== 'island', v.price);
    q('[data-vne-spdp]').setAttribute('href', v.url);
    var buy = q('[data-vne-buy]');
    buy.disabled = !v.avail && !has;
    buy.innerHTML = has ? bi('Đã chọn · Xem đơn hàng', 'Added · View order')
      : !v.avail ? bi('Hết hàng', 'Sold out')
      : S.qty > 1 ? bi('Mua ' + S.qty + (p.jars ? ' set · ' : ' hộp · ') + money(qtyPrice(v.price, S.qty, others).tot), 'Buy ' + S.qty + (p.jars ? ' sets · ' : ' boxes · ') + money(qtyPrice(v.price, S.qty, others).tot))
      : bi('Mua ngay · ' + money(v.price), 'Buy now · ' + money(v.price));
    var name = isEn() ? p.name[1] : p.name[0];
    label(q('[data-vne-sheet]'), p.name[0], p.name[1] || name);
  }
  function buyFromSheet() {
    var p = BY[S.key];
    if (!p) return;
    var v = variantOf(p, S.big);
    track('buy_click', { id: S.key, size: S.big ? 'large' : 'main', qty: S.qty });
    var card = q('[data-vne-card="' + S.key + '"] .vne-card-open');
    pin(card);
    closeSheet(true);
    if (inCart(v.vid)) openDrawer();
    else add(v.vid, S.qty);
  }
  function quickAdd(key, btn) {
    var p = BY[key];
    if (!p) return;
    pin(btn);
    var card = btn && btn.closest && btn.closest('[data-vne-card]'), big = !!(card && card.getAttribute('data-vne-big') === '1' && p.large);
    var hit = (cart && cart.items || []).some(function (it) { return it.variant_id === p.vid || (p.large && it.variant_id === p.large.vid); });
    track('quick_add', { id: key, in_cart: hit, size: big ? 'large' : 'main' });
    if (hit) { openDrawer(); return; }
    add(big ? p.large.vid : p.vid, 1);
  }

  /* ---------- cart ---------- */
  var cart = null, busy = false, attrTimer = 0, attrPending = null;
  /* The cart and Shopify's checkout follow the reading language: a cart built on /vi/ opens a Vietnamese checkout
     (the store publishes vi), English readers stay on the primary locale. Without published locales: the page's own root. */
  var LOCS = D.locales || [];
  function base() {
    if (!LOCS.length) return ROOT;
    if (isEn()) return '/';
    return LOCS.indexOf('vi') > -1 ? '/vi/' : ROOT;
  }
  function api(path, body) {
    var opt = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) { opt.method = 'POST'; opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return fetch(base() + path, opt).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || 'HTTP ' + r.status); e.status = r.status; throw e; }
        return j;
      });
    });
  }
  function isAddon(it) { return !!(it.properties && it.properties._addon); }
  /* The store's automatic multi-box discount (Shopify Discounts "Bundle Discount" 2+ / "Tier 3" 3+), explained before
     checkout so nobody meets an unexplained price there. Shopify does the maths at checkout; these are the same rules. */
  var BUNDLE = D.bundle || null;
  function bundlePct(n) { return !BUNDLE ? 0 : n >= 3 ? (BUNDLE[1] || 0) : n >= 2 ? (BUNDLE[0] || 0) : 0; }
  function afterBundle(cents, n) { var pc = bundlePct(n); return pc ? Math.round(cents * (100 - pc) / 100) : cents; }
  function boxCount() { return ((cart && cart.items) || []).filter(function (it) { return !isAddon(it) && it.final_line_price > 0 && BYVID[it.variant_id]; }).reduce(function (a, it) { return a + it.quantity; }, 0); }
  function qtyPrice(unit, n, others) {
    var pc = bundlePct(n + (others || 0)), tot = afterBundle(unit * n, n + (others || 0));
    return { tot: tot, html: esc(money(tot)) + (pc ? '<span class="vne-save">' + bi('giảm ' + pc + '%', pc + '% off') + '</span>' : '') };
  }
  function paidItems() { return ((cart && cart.items) || []).filter(function (it) { return !isAddon(it) && it.final_line_price > 0; }); }
  function count() { return paidItems().reduce(function (a, it) { return a + it.quantity; }, 0); }
  function setCart(c) {
    cart = c || { items: [], item_count: 0, total_price: 0 };
    paint();
    try { document.dispatchEvent(new CustomEvent('vne:cart', { detail: cart })); } catch (e) {}
    return cart;
  }
  function loadCart() { return api('cart.js').then(setCart); }
  /* A free-gift app may add or drop $0 lines a moment after a change; look again so the order shows them. */
  var lookTimer = 0;
  function lookAgain() { clearTimeout(lookTimer); lookTimer = setTimeout(function () { loadCart().catch(function () {}); }, 1400); }
  var GIFT_PROP = { 'Quà tặng kèm': 'Táo đỏ + đường phèn' };   /* same text on every line so lines still merge */
  function add(vid, n) {
    if (busy) return Promise.resolve({ ok: false, busy: true });   /* callers (cart page, collection cards) can wait on every add */
    busy = true;
    var hit = BYVID[vid], p = hit && hit.p, price = p ? variantOf(p, hit.big).price : PD && PD.vid === vid ? PD.price : 0;
    var nest = p ? !p.jars : !!(PD && PD.vid === vid && PD.nest), item = { id: vid, quantity: n };
    if (D.freeGift && nest) item.properties = GIFT_PROP;
    setError('');
    return api('cart/add.js', { items: [item] })
      .then(function () {
        track('add_to_cart', { id: p ? p.key : PD && PD.vid === vid ? PD.handle : String(vid), size: hit && hit.big ? 'large' : 'main', qty: n, value: price * n / 100, currency: D.currency });
        pixel('AddToCart', { content_ids: [String(vid)], content_type: 'product', num_items: n, value: price * n / 100, currency: D.currency }, true);
        return loadCart();
      })
      .then(function () { openDrawer(); lookAgain(); return { ok: true, cart: cart }; })
      .catch(function (e) {
        openDrawer();
        setError(e && e.message);
        return { ok: false, error: e && e.message };
      })
      .then(function (r) { busy = false; return r; });
  }
  function change(key, qty) {
    if (busy) return Promise.resolve({ ok: false, busy: true });
    busy = true;
    setError('');
    return api('cart/change.js', { id: key, quantity: qty })
      .then(function (c) {
        /* only dependent lines left (gift-box add-on or a free-gift app's $0 lines): empty the cart, as the product page does */
        var paid = (c.items || []).filter(function (it) { return !isAddon(it) && it.final_line_price > 0; });
        if (c.items && c.items.length && !paid.length) return api('cart/clear.js', {}).then(setCart);
        setCart(c);
        lookAgain();
      })
      .then(function () { return { ok: true, cart: cart }; }, function (e) { setError(e && e.message, true); loadCart().catch(function () {}); return { ok: false, error: e && e.message }; })
      .then(function (r) { busy = false; return r; });
  }
  function setError(msg, upd) {
    var box = q('[data-vne-carterr]');
    if (!box) return;
    box.hidden = !msg;
    if (msg) box.innerHTML = upd ? bi('Chưa cập nhật được đơn hàng (' + msg + '). Xin gọi ' + D.phone + ' để đặt hàng.', 'We couldn’t update your order (' + msg + '). Please call ' + D.phone + ' to order.')
      : bi('Chưa thêm được vào giỏ (' + msg + '). Xin gọi ' + D.phone + ' để đặt hàng.', 'We couldn’t add it to your order (' + msg + '). Please call ' + D.phone + ' to order.');
  }
  /* a store title typed in capitals reads in sentence case, as on its product page */
  function calm(t) { t = String(t || ''); return t !== t.toUpperCase() || t === t.toLowerCase() ? t : t.charAt(0) + t.slice(1).toLowerCase(); }
  function grams(title) { var m = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*(kg|gr|g)\b/i); return m ? m[1] + (m[2].toLowerCase() === 'kg' ? 'kg' : 'g') : ''; }
  function lineName(it) {
    var hit = BYVID[it.variant_id];
    if (hit) return hit.p.name;
    var h = String(it.handle || ''), title = String(it.product_title || it.title || ''), g = grams(title);
    if (h.indexOf('premium-gift-box') > -1) return ['Hộp quà Vinanest', 'Vinanest gift box'];
    if (h.indexOf('dried-large-jujube-apples') > -1) return [('Táo đỏ sấy loại lớn ' + g).trim(), ('Dried large jujube apples ' + g).trim()];
    if (h.indexOf('jujube') > -1 && it.final_line_price === 0) return [('Táo đỏ khô ' + g).trim(), ('Dried red dates ' + g).trim()];
    if (h.indexOf('sugar') > -1 && it.final_line_price === 0) return [('Đường phèn ' + g).trim(), ('Rock sugar ' + g).trim()];
    var m = title.match(/^(.*?)\(([^)]*)\)(.*)$/);   /* "ENGLISH (VIỆT) 200GR" → Việt 200g / English 200g */
    if (m) { var outer = (m[1] + ' ' + m[3]).replace(/\b\d+(?:[.,]\d+)?\s*(kg|gr|g)\b/i, ''); return [(calm(m[2].trim()) + (g ? ' ' + g : '')).trim(), (calm(outer.trim()) + (g ? ' ' + g : '')).trim()]; }
    var c = calm(title);
    return [c, c];
  }
  function lineSize(it) {
    var hit = BYVID[it.variant_id];
    if (hit) return variantOf(hit.p, hit.big).size;
    var t = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    return [t, t];
  }
  function lineImg(it) { var hit = BYVID[it.variant_id]; if (hit) return variantOf(hit.p, hit.big).img; if (String(it.handle || '').indexOf('premium-gift-box') > -1) return '';   /* its only photo is a generated image with another shop's number */
    return it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : ''; }
  function lineHtml(it, addon) {
    var nm = lineName(it), sz = lineSize(it), k = esc(it.key), img = lineImg(it), was = it.original_line_price > it.final_line_price;
    var unitVi = BYVID[it.variant_id] && BYVID[it.variant_id].p.jars ? 'set' : 'hộp', unitEn = unitVi === 'set' ? 'set' : 'box';
    return '<div class="vne-line">' +
      '<span class="vne-line-img"' + (img ? ' style="background-image:url(&quot;' + esc(img) + '&quot;)"' : '') + '></span>' +
      '<div class="vne-line-m">' +
        '<div class="vne-line-t"><b>' + bi(nm[0], nm[1]) + '</b><span>' + (was ? '<s style="font-weight:500;color:var(--ink3);margin-right:6px">' + esc(money(it.original_line_price)) + '</s>' : '') + esc(money(it.final_line_price)) + '</span></div>' +
        (sz[0] ? '<small>' + bi(sz[0], sz[1]) + '</small>' : '') +
        '<div class="vne-line-q">' +
          (addon ? '<span></span>' :
          '<div class="vne-step" role="group" aria-label="' + (isEn() ? 'Quantity' : 'Số lượng') + '" data-vi-label="Số lượng" data-en-label="Quantity">' +
            '<button type="button" data-vne-dec="' + k + '" data-q="' + it.quantity + '" aria-label="' + (isEn() ? 'One less' : 'Bớt 1 ' + unitVi) + '" data-vi-label="Bớt 1 ' + unitVi + '" data-en-label="One less ' + unitEn + '">−</button>' +
            '<span aria-live="polite">' + it.quantity + '</span>' +
            '<button type="button" data-vne-inc="' + k + '" data-q="' + it.quantity + '" aria-label="' + (isEn() ? 'One more' : 'Thêm 1 ' + unitVi) + '" data-vi-label="Thêm 1 ' + unitVi + '" data-en-label="One more ' + unitEn + '">+</button>' +
          '</div>') +
          '<button type="button" class="vne-rm" data-vne-rm="' + k + '">' + bi('Xóa', 'Remove') + '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }
  function paint() {
    var items = (cart && cart.items) || [];
    /* card buttons: dark "Added · View order" once that nest is in the order */
    qa('[data-vne-add]').forEach(function (b) {
      var p = BY[b.getAttribute('data-vne-add')];
      if (!p) return;
      var hit = items.some(function (it) { return it.variant_id === p.vid || (p.large && it.variant_id === p.large.vid); });
      b.classList.toggle('vne-in', hit);
      var price = b.querySelector('.vne-add-r b');
      if (hit) label(b, 'Đã thêm vào giỏ, xem đơn hàng: ' + p.name[0], 'Added to cart, view your order: ' + p.name[1]);
      else label(b, 'Thêm vào giỏ: ' + p.name[0] + ', ' + (price ? price.textContent : ''), 'Add to cart: ' + p.name[1] + ', ' + (price ? price.textContent : ''));
    });
    paintBar();
    paintHdrCart();
    renderDrawer();
    if (sheetRoot && sheetRoot.classList.contains('vne-on')) renderSheet();
    if (PD) pdpPaint();
    checkBar();
  }

  /* header order button: paid boxes in the order (free gifts not counted), same number as the drawer */
  function paintHdrCart() {
    var n = count();
    qa('[data-vne-hcart]').forEach(function (a) {
      var c = a.querySelector('[data-vne-hcount]');
      if (c) { c.textContent = n; c.hidden = !n; }
      a.setAttribute('data-vi-label', 'Giỏ hàng' + (n ? ', ' + n + ' món' : ''));
      a.setAttribute('data-en-label', 'Your order' + (n ? ', ' + n + (n > 1 ? ' items' : ' item') : ''));
      a.setAttribute('aria-label', a.getAttribute(isEn() ? 'data-en-label' : 'data-vi-label'));
    });
  }

  /* ---------- site menu ---------- */
  function menuBtn(open) { var b = q('[data-vne-menuopen]'); if (b) b.setAttribute('aria-expanded', String(open)); }
  function openMenu() {
    if (!menuRoot) return;
    remember();
    menuRoot.classList.add('vne-on');
    menuBtn(true);
    lock();
    focusIn('[data-vne-menux]');
    track('menu_open', {});
  }
  function closeMenu() {
    if (!menuRoot || !menuRoot.classList.contains('vne-on')) return;
    menuRoot.classList.remove('vne-on');
    menuBtn(false);
    lock();
    restore();
  }
  function menuLink(a, e) {
    var h = a.getAttribute('href') || '';
    track('menu_link', { to: h });
    if (h.charAt(0) !== '#') return;
    e.preventDefault();
    closeMenu();
    var el = q(h);
    setTimeout(function () { scrollToEl(el, 8); }, 60);
  }

  /* ---------- order drawer ---------- */
  var done = false;
  function openDrawer(toForm) {
    if (!drawerRoot) return;
    if (!drawerRoot.classList.contains('vne-on')) remember();
    closeSheet(true);
    renderDrawer();
    drawerRoot.classList.add('vne-on');
    lock();
    var body = q('[data-vne-drbody]');
    if (toForm) {
      requestAnimationFrame(function () {
        var f = q('[data-vne-cbform]');
        if (body && f) body.scrollTop = f.offsetTop - 8;
        focusIn('[data-vne-name]');
      });
    } else {
      if (body) body.scrollTop = 0;
      focusIn('[data-vne-drawerx]');
    }
    track('order_open', { items: count() });
  }
  function closeDrawer() {
    if (!drawerRoot || !drawerRoot.classList.contains('vne-on')) return;
    drawerRoot.classList.remove('vne-on');
    lock();
    restore();
    if (done) setTimeout(function () { if (!drawerRoot.classList.contains('vne-on')) { done = false; renderDrawer(); } }, 500);
  }
  function renderDrawer() {
    if (!drawerRoot) return;
    var items = (cart && cart.items) || [];
    var main = items.filter(function (it) { return !isAddon(it) && it.final_line_price > 0; });
    var addons = items.filter(function (it) { return isAddon(it) && it.final_line_price > 0; });
    var free = items.filter(function (it) { return it.final_line_price === 0; });
    var any = main.length > 0;
    var view = q('[data-vne-cartview]'), form = q('[data-vne-cbform]'), doneEl = q('[data-vne-done]'), foot = q('[data-vne-drfoot]');
    if (view) view.hidden = done;
    if (form) form.hidden = done;
    if (doneEl) doneEl.hidden = !done;
    if (foot) foot.hidden = done || !any;
    q('[data-vne-empty]').hidden = any;
    q('[data-vne-lines]').innerHTML = main.map(function (it) { return lineHtml(it, false); }).join('') + addons.map(function (it) { return lineHtml(it, true); }).join('');
    q('[data-vne-sum]').hidden = !any;
    var more = q('[data-vne-more]'); if (more) more.hidden = !any;
    var giftbox = q('[data-vne-giftbox]'); if (giftbox) giftbox.hidden = !any;
    /* free red dates & rock sugar: show the app's $0 lines if it added them, else the promise itself */
    var freeRows = q('[data-vne-freerows]');
    if (freeRows) freeRows.innerHTML = free.map(function (it) {
      var h = it.handle || '', nm = h.indexOf('jujube') > -1 ? ['Táo đỏ', 'Red dates'] : h.indexOf('sugar-candy') > -1 ? ['Đường phèn', 'Rock sugar'] : [it.product_title, it.product_title];
      return '<div class="vne-gift-row"><span>' + bi(nm[0] + (it.quantity > 1 ? ' × ' + it.quantity : ''), nm[1] + (it.quantity > 1 ? ' × ' + it.quantity : '')) + '</span><span class="vne-free">' + bi('Tặng kèm', 'Included') + '</span></div>';
    }).join('');
    var giftRow = q('[data-vne-giftrow]');
    if (giftRow) giftRow.hidden = !(D.freeGift && !free.length && main.some(function (it) { var h = BYVID[it.variant_id]; return h && !h.p.jars; }));
    /* discounts: the product-level bundle discount (lines show it struck through) plus any order-level one; the free gifts' $0 lines are not a "discount" */
    var lineOff = main.reduce(function (a, it) { return a + Math.max(0, (it.original_line_price || 0) - (it.final_line_price || 0)); }, 0);
    var off = (cart ? Math.max(0, (cart.items_subtotal_price || 0) - (cart.total_price || 0)) : 0) + lineOff, dr = q('[data-vne-discrow]'), nb2 = boxCount(), pcNow = bundlePct(nb2);
    if (dr) {
      dr.hidden = !off;
      if (off) {
        q('[data-vne-disc]').textContent = '−' + money(off);
        var dl = dr.firstElementChild;
        if (dl) dl.innerHTML = pcNow && lineOff ? bi('Đã giảm ' + pcNow + '% (mua ' + nb2 + ' hộp)', pcNow + '% off (' + nb2 + ' boxes)') : bi('Giảm giá', 'Discount');
      }
    }
    var brow = q('[data-vne-bundlerow]'), pcNext = bundlePct(nb2 + 1);
    if (brow) {
      var inList = main.filter(function (it) { return BYVID[it.variant_id]; }), boxes = inList.filter(function (it) { return !BYVID[it.variant_id].p.jars; });
      var last = boxes[0] || inList[0], allNest = main.every(function (it) { return BYVID[it.variant_id]; });
      brow.hidden = !(last && pcNext > pcNow);
      if (!brow.hidden) {
        var ln = lineName(last);
        brow.innerHTML = '<p>' + (allNest ? bi('Thêm 1 hộp nữa: cả đơn được giảm ' + pcNext + '%.', 'Add one more box: ' + pcNext + '% off the whole order.')
          : bi('Thêm 1 hộp nữa: các hộp yến được giảm ' + pcNext + '%.', 'Add one more box: ' + pcNext + '% off the nest boxes.')) + '</p>' +
          '<button type="button" class="vne-btn vne-btn--line" data-vne-bundleadd="' + esc(last.key) + '" data-q="' + last.quantity + '">' + bi('+ 1 hộp ' + ln[0], '+ 1 box of ' + ln[1]) + '</button>';
      }
    }
    var promo = W.VINANEST_PROMO, pr = q('[data-vne-promorow]'), pOn = !!(promo && promo.live && promo.code && promo.pct);
    if (pr) { pr.hidden = !pOn; if (pOn) q('[data-vne-promol]').innerHTML = bi('Mã ' + promo.code + ': giảm ' + promo.pct + '% khi thanh toán', 'Code ' + promo.code + ': ' + promo.pct + '% off at checkout'); }
    var e = eta(), er = q('[data-vne-etarow]');
    if (er) er.hidden = !e;
    if (e) q('[data-vne-eta]').innerHTML = bi(nb(e[0]), nb(e[1]));
    var total = money(cart ? cart.total_price : 0);
    q('[data-vne-total]').textContent = total;
    var t2 = q('[data-vne-total2]'); if (t2) t2.textContent = total;
    /* the store's only US rate is free from D.shipMin: below it Shopify checkout has no way to ship, so say so here */
    var mr = q('[data-vne-minrow]'), small = !D.smallShip && D.shipMin && count() > 0 && (cart.total_price || 0) < D.shipMin;
    if (mr) { mr.hidden = !small; if (small) mr.innerHTML = bi('Đơn từ ' + money(D.shipMin) + ' mới giao được. Thêm một hộp yến để đặt hàng.', 'Orders ship from ' + money(D.shipMin) + '. Add a nest box to check out.'); }
    syncGift();
  }

  /* gift note → cart attributes, so the order in Shopify admin carries it */
  var giftChk = q('[data-vne-giftchk]'), note = q('[data-vne-note]'), giftSynced = false;
  function syncGift() {
    if (!giftChk || giftSynced || !cart) return;
    giftSynced = true;
    var a = cart.attributes || {}, on = !!a['Quà biếu / Gift'];
    giftChk.setAttribute('aria-pressed', String(on));
    q('[data-vne-giftnote]').hidden = !on;
    if (note) note.value = a['Lời chúc / Card message'] || '';
  }
  function saveGift() {
    if (!giftChk) return Promise.resolve();
    var on = giftChk.getAttribute('aria-pressed') === 'true';
    var attrs = { 'Quà biếu / Gift': on ? 'Có / Yes' : '', 'Lời chúc / Card message': on && note ? note.value.trim() : '' }, msg = attrs['Lời chúc / Card message'];
    /* the order note is the first thing staff read on an order: say it is a gift and copy the card message */
    /* same text as the cart page; a note the customer wrote themselves is never overwritten */
    var body = { attributes: attrs }, was = (cart && cart.note) || '', ours = !was || was.indexOf('QUÀ BIẾU') === 0;
    if (ours) body.note = on ? 'QUÀ BIẾU / GIFT: kèm thiệp, không để giá hay hóa đơn trong hộp.' + (msg ? '\nLời chúc / Card: ' + msg : '') : '';
    attrPending = api('cart/update.js', body).then(function (c) { if (c && c.items) cart = c; }).catch(function () {});
    return attrPending;
  }
  function saveGiftSoon() { clearTimeout(attrTimer); attrTimer = setTimeout(saveGift, 600); }
  function checkout(e) {
    if (e) e.preventDefault();
    var promo = W.VINANEST_PROMO, url = base() + 'checkout';
    if (promo && promo.live && promo.code) url = base() + 'discount/' + encodeURIComponent(promo.code) + '?redirect=' + encodeURIComponent(base() + 'checkout');
    var c = cart || {};
    pixel('InitiateCheckout', { value: (c.total_price || 0) / 100, currency: c.currency || D.currency, num_items: count(), content_ids: paidItems().map(function (it) { return String(it.variant_id); }), content_type: 'product' }, true);
    track('checkout', { value: (c.total_price || 0) / 100, items: count() });
    var went = false, go = function () { if (!went) { went = true; W.location.href = url; } };
    clearTimeout(attrTimer);
    (giftChk ? saveGift() : Promise.resolve()).then(go, go);
    setTimeout(go, 2500);
  }

  /* ---------- call-back form (Shopify contact form) ---------- */
  var form = q('[data-vne-cbform]'), pref = 'call';
  function digits(s) { var d = String(s || '').replace(/\D/g, ''); if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1); return d; }
  function fmtPhone(s) { var d = digits(s); return d.length === 10 ? '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6) : String(s || '').trim(); }
  function asYouType(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length > 10 && d.charAt(0) === '1') d = d.slice(1);
    d = d.slice(0, 10);
    if (d.length < 4) return d;
    if (d.length < 7) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  function orderText() {
    var items = (cart && cart.items) || [], L = [];
    items.forEach(function (it) {
      var nm = lineName(it), sz = lineSize(it);
      L.push('- ' + it.quantity + ' × ' + nm[0] + (sz[0] ? ' (' + sz[0] + ')' : '') + ' — ' + (it.final_line_price === 0 ? 'Tặng kèm / Free' : money(it.final_line_price)));
    });
    if (!L.length) L.push('Chưa chọn sản phẩm / No products chosen yet');
    else L.push('Tổng / Total: ' + money(cart.total_price));
    if (giftChk && giftChk.getAttribute('aria-pressed') === 'true') L.push('Quà biếu / Gift: Có / Yes' + (note && note.value.trim() ? ' — Lời chúc / Card: ' + note.value.trim() : ''));
    L.push('Ngôn ngữ / Language: ' + (isEn() ? 'English' : 'Tiếng Việt'));
    return L.join('\n');
  }
  function fieldError(which, on) {
    var wrap = q(which === 'name' ? '[data-vne-fname]' : '[data-vne-fphone]'), msg = q(which === 'name' ? '[data-vne-errname]' : '[data-vne-errphone]');
    if (wrap) wrap.classList.toggle('vne-err', on);
    if (msg) msg.hidden = !on;
    var input = q(which === 'name' ? '[data-vne-name]' : '[data-vne-phone]');
    if (input) { if (on) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
  }
  function submitCb(e) {
    if (form.vneGo) { form.vneGo = false; return; }
    var name = q('[data-vne-name]'), phone = q('[data-vne-phone]');
    var badName = !name.value.trim(), badPhone = digits(phone.value).length !== 10;
    fieldError('name', badName); fieldError('phone', badPhone);
    if (badName || badPhone) {
      e.preventDefault();
      var el = badName ? name : phone, body = q('[data-vne-drbody]');
      if (body) body.scrollTo({ top: el.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop - 80, behavior: REDUCE ? 'auto' : 'smooth' });
      el.focus({ preventScroll: true });
      return;
    }
    phone.value = fmtPhone(phone.value);
    q('[data-vne-cbbody]').value = orderText();
    q('[data-vne-cbpref]').value = pref === 'zalo' ? 'Zalo' : pref === 'sms' ? 'Nhắn tin / Text' : 'Gọi điện / Call';
    try { sessionStorage.setItem('vne_cb', JSON.stringify({ name: name.value.trim(), phone: phone.value, pref: pref })); } catch (x) {}
    var c = cart || {};
    track('callback_submit', { pref: pref, items: count(), value: (c.total_price || 0) / 100 });
    pixel('Lead', { value: (c.total_price || 0) / 100, currency: D.currency, content_name: 'call-back' });
    var send = q('[data-vne-cbsend]');
    if (send) { send.disabled = true; send.style.opacity = '.7'; }
    /* save the gift note to the cart first, then submit again through the submit event (Shopify's captcha hooks it) */
    if (giftChk) {
      e.preventDefault();
      clearTimeout(attrTimer);
      var go = function () { form.vneGo = true; if (form.requestSubmit) form.requestSubmit(); else form.submit(); };
      saveGift().then(go, go);
    }
  }
  function showDone(info) {
    done = true;
    var o = openNow(), ph = nb(fmtPhone(info.phone || '')), p = info.pref || 'call';
    var whenVi = o.open ? 'trong 15 phút' : 'từ ' + hourVi(D.hoursOpen) + ' sáng ' + (o.early ? 'nay' : 'mai') + ' (giờ California)';
    var whenEn = o.open ? 'within 15 minutes' : 'after ' + hourEn(D.hoursOpen) + ' ' + (o.early ? 'today' : 'tomorrow') + ' (Pacific time)';
    var t = p === 'zalo' ? ['Vinanest sẽ nhắn Zalo cho số ' + ph + ' ' + whenVi + ' để xác nhận đơn. Zalo của Vinanest:', 'We’ll message ' + ph + ' on Zalo ' + whenEn + ' to confirm. Our Zalo:']
      : p === 'sms' ? ['Vinanest sẽ nhắn tin tới số ' + ph + ' ' + whenVi + ' để xác nhận đơn, từ số:', 'We’ll text ' + ph + ' ' + whenEn + ' to confirm, from:']
      : ['Vinanest sẽ gọi số ' + ph + ' ' + whenVi + ' để xác nhận đơn và hướng dẫn thanh toán, từ số:', 'We’ll call ' + ph + ' ' + whenEn + ' to confirm and arrange payment, from:'];
    var hint = p === 'zalo' ? ['Xin quý khách mở Zalo để trả lời.', 'Please open Zalo to reply.'] : p === 'sms' ? ['Quý khách chỉ cần trả lời tin nhắn.', 'Just reply to the text.'] : ['Xin quý khách nhớ nghe máy.', 'Please pick up when we call.'];
    q('[data-vne-donetext]').innerHTML = biP(t);
    q('[data-vne-donehint]').innerHTML = biP(hint);
    renderDrawer();
  }
  function editPhone() {
    done = false;
    renderDrawer();
    var info = {}; try { info = JSON.parse(sessionStorage.getItem('vne_cb') || '{}'); } catch (x) {}
    var name = q('[data-vne-name]'), phone = q('[data-vne-phone]');
    if (name && info.name && !name.value) name.value = info.name;
    if (phone && info.phone && !phone.value) phone.value = info.phone;
    if (info.pref) setPref(info.pref);
    var send = q('[data-vne-cbsend]'); if (send) { send.disabled = false; send.style.opacity = ''; }
    requestAnimationFrame(function () {
      var body = q('[data-vne-drbody]');
      if (body && phone) body.scrollTop = phone.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop - 120;
      if (phone) phone.focus({ preventScroll: true });
    });
    track('edit_phone');
  }
  function setPref(p) {
    pref = p;
    qa('[data-vne-pref]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-vne-pref') === p)); });
  }
  function vcard() {
    var a = String(D.address || '').split(',').map(function (x) { return x.trim(); }), rz = (a[2] || '').split(/\s+/);
    var v = ['BEGIN:VCARD', 'VERSION:3.0', 'N:;Vinanest;;;', 'FN:Vinanest', 'ORG:Vinanest', 'TEL;TYPE=WORK,VOICE:' + D.tel];
    if (D.email) v.push('EMAIL;TYPE=WORK:' + D.email);
    if (a[0]) v.push('ADR;TYPE=WORK:;;' + a[0] + ';' + (a[1] || '') + ';' + (rz[0] || '') + ';' + (rz[1] || '') + ';USA');
    v.push('URL:' + location.origin, 'END:VCARD');
    try {
      var url = URL.createObjectURL(new Blob([v.join('\r\n')], { type: 'text/vcard;charset=utf-8' })), link = document.createElement('a');
      link.href = url; link.download = 'Vinanest.vcf';
      B.appendChild(link); link.click();
      setTimeout(function () { URL.revokeObjectURL(url); link.remove(); }, 2000);
    } catch (x) { W.location.href = 'tel:' + D.tel; }
    track('save_contact');
  }

  /* ---------- order section: open-now dot, call vs call-back ---------- */
  function paintStatus() {
    var st = q('[data-vne-status]');
    if (!st) return;
    if (!D.hoursOn) { st.hidden = true; return; }
    var o = openNow(), hv = hourVi(D.hoursClose), he = hourEn(D.hoursClose), ov = hourVi(D.hoursOpen), oe = hourEn(D.hoursOpen);
    st.hidden = false;
    st.classList.toggle('vne-open', o.open);
    q('[data-vne-st-l]', st).innerHTML = o.open ? bi('Đang có người nghe máy', 'Someone is here to answer') : bi('Ngoài giờ làm việc', 'Closed now');
    q('[data-vne-st-s]', st).innerHTML = o.open ? bi('Đến ' + hv + ' (giờ California)', 'Until ' + he + ' Pacific time')
      : bi('Mở lại lúc ' + ov + ' sáng ' + (o.early ? 'nay' : 'mai') + ' (giờ California)', 'Opens at ' + oe + ' ' + (o.early ? 'today' : 'tomorrow') + ' Pacific time');
    var cb = !!q('[data-vne-cbopen]');
    qa('[data-vne-ifopen]').forEach(function (el) { el.hidden = !o.open && cb; });
    qa('[data-vne-ifclosed]').forEach(function (el) { el.hidden = o.open || !cb; });
  }

  /* ---------- workshop video ---------- */
  var vid = q('[data-vne-clip]'), userPaused = false, full = false;
  function setPlayIcon(paused) {
    var t = q('[data-vne-vidtog]');
    if (!t) return;
    q('[data-vne-pause]', t).hidden = paused;
    q('[data-vne-play]', t).hidden = !paused;
    label(t, paused ? 'Phát video' : 'Tạm dừng video', paused ? 'Play video' : 'Pause video');
  }
  function playClip() { if (!vid || full) return; vid.muted = true; var p = vid.play(); if (p && p.catch) p.catch(function () { setPlayIcon(true); }); setPlayIcon(false); }
  function setupVideo() {
    if (!vid) return;
    vid.muted = true;
    var dp = vid.getAttribute('data-poster');
    if (dp) {
      if ('IntersectionObserver' in W) { var pio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { vid.poster = dp; pio.disconnect(); } }, { rootMargin: '600px 0px' }); pio.observe(vid); }
      else vid.poster = dp;
    }
    var cap = q('[data-vne-cap]'), last = -1;
    vid.addEventListener('timeupdate', function () {
      if (full || !cap) return;
      var t = vid.currentTime || 0, i = 0;
      while (i < CUES.length - 1 && t >= CUES[i + 1][0]) i++;
      if (i !== last) { last = i; cap.innerHTML = biP(CUES[i].slice(1)); }
    });
    if (REDUCE) { setPlayIcon(true); return; }
    if ('IntersectionObserver' in W) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (full) return;
          if (en.isIntersecting && !userPaused) playClip();
          else if (!en.isIntersecting && !vid.paused) vid.pause();
        });
      }, { threshold: 0.3 }).observe(vid);
    } else playClip();
  }
  function toggleClip() {
    if (!vid) return;
    if (vid.paused) { userPaused = false; playClip(); track('clip_play'); }
    else { userPaused = true; vid.pause(); setPlayIcon(true); }
  }
  function fullVideo(btn) {
    if (!vid) return;
    full = true;
    vid.pause();
    vid.loop = false;
    vid.muted = false;
    vid.removeAttribute('muted');
    vid.controls = true;
    vid.poster = vid.getAttribute('data-full-poster') || vid.poster;
    vid.src = vid.getAttribute('data-full');
    var box = q('[data-vne-vid]'); if (box) box.classList.add('vne-full');
    if (btn) btn.hidden = true;
    label(vid, 'Video tại xưởng, có tiếng', 'Workshop video with sound');
    var p = vid.play(); if (p && p.catch) p.catch(function () {});
    track('video_full');
  }

  /* ---------- lab report ---------- */
  function openLab() {
    if (!lab) return;
    remember();
    lab.classList.add('vne-on');
    var b = q('[data-vne-labbody]'); if (b) b.scrollTop = 0;
    lock();
    focusIn('[data-vne-labx]');
    track('lab_open');
  }
  function closeLab() { if (!lab || !lab.classList.contains('vne-on')) return; lab.classList.remove('vne-on'); lock(); restore(); }

  /* ---------- compare table ---------- */
  var cmpBuilt = false;
  function buildCompare() {
    var rows = q('[data-vne-cmprows]');
    if (!rows || cmpBuilt) return;
    cmpBuilt = true;
    rows.innerHTML = PRODUCTS.slice().sort(function (a, b) { return a.price / a.bowls - b.price / b.bowls; }).map(function (p) {
      var use = (p.groups || []).map(function (k) { return GROUP[k]; }).filter(Boolean);
      var sold = !p.avail && !(p.large && p.large.avail);
      var vi = use.map(function (u) { return u[2]; }).concat(p.jars ? [p.size[0]] : [p.grams + 'g (' + oz(p.grams) + ')']).concat(sold ? ['Hết hàng'] : []).join(' · ');
      var en = use.map(function (u) { return u[3]; }).concat(p.jars ? [p.size[1]] : [p.grams + 'g (' + oz(p.grams) + ')']).concat(sold ? ['Sold out'] : []).join(' · ');
      return '<button type="button" class="vne-cmp-row" data-vne-open="' + esc(p.key) + '" aria-haspopup="dialog"><span><b>' + biP(p.name) + '</b><small>' + bi(vi, en) + '</small></span><span><b>' + esc(money(p.price)) + '</b><small>' + perText(p, p) + '</small></span></button>';
    }).join('');
  }
  function toggleCompare(btn) {
    var box = q('[data-vne-cmp]'), open = btn.getAttribute('aria-expanded') !== 'true';
    if (open) buildCompare();
    box.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    q('[data-vne-cmpl]', btn).innerHTML = open ? bi('Ẩn bảng so sánh', 'Hide comparison') : bi('So sánh nhanh các loại yến', 'Compare all kinds');
    if (open) track('compare_open');
  }

  /* ---------- FAQ ---------- */
  function toggleFaq(btn) {
    var open = btn.getAttribute('aria-expanded') !== 'true';
    qa('.vne-faq-q[aria-expanded="true"]').forEach(function (b) { if (b !== btn) b.setAttribute('aria-expanded', 'false'); });
    btn.setAttribute('aria-expanded', String(open));
    if (open) track('faq_open', { q: (btn.closest('[data-faq]') || btn).getAttribute('data-faq') || '' });
  }

  /* ---------- product page: photos, viewer, quantity, buy ---------- */
  function pdpGo(i) {
    var n = PD.slides.length;
    if (!n) return;
    P.gal = ((i % n) + n) % n;
    var sl = PD.slides[P.gal], img = q('[data-vne-pimg]');
    if (img && img.getAttribute('src') !== sl.src) {
      var shown = function () { img.classList.remove('vne-fade'); img.removeEventListener('load', shown); };
      img.classList.add('vne-fade');
      img.addEventListener('load', shown);
      img.setAttribute('srcset', sl.srcset);
      img.setAttribute('src', sl.src);
      img.setAttribute('height', String(Math.round(1200 / (sl.ratio || 1))));
      img.alt = sl.alt || '';
      setTimeout(shown, 700);
    }
    var cap = q('[data-vne-pcap]'); if (cap) cap.innerHTML = sl.cap ? biP(sl.cap) : '';
    var cnt = q('[data-vne-pcount]'); if (cnt) cnt.textContent = (P.gal + 1) + ' / ' + n;
    var box = q('[data-vne-pthumbs]');
    qa('[data-vne-pthumb]').forEach(function (b) {
      var on = +b.getAttribute('data-vne-pthumb') === P.gal;
      b.setAttribute('aria-pressed', String(on));
      if (on && box) {
        var br = b.getBoundingClientRect(), cr = box.getBoundingClientRect();
        if (br.left < cr.left || br.right > cr.right) box.scrollBy({ left: br.left - cr.left - (cr.width - br.width) / 2, behavior: REDUCE ? 'auto' : 'smooth' });
      }
    });
    if (zoomEl && zoomEl.classList.contains('vne-on')) zoomPaint();
  }
  function zoomPaint() {
    var sl = PD.slides[P.gal], img = q('[data-vne-zimg]', zoomEl), n = PD.slides.length, c = q('[data-vne-zcount]', zoomEl);
    if (!sl || !img) return;
    if (P.z) zoomSet(false);
    if (img.getAttribute('src') !== sl.big) img.setAttribute('src', sl.big);
    img.alt = sl.alt || '';
    if (c) c.textContent = n > 1 ? (P.gal + 1) + ' / ' + n : '';
  }
  function zoomSet(on, fx, fy) {
    P.z = on;
    zoomEl.classList.toggle('vne-zin', on);
    var body = q('[data-vne-zbody]', zoomEl);
    if (!body) return;
    if (!on) { body.scrollLeft = 0; body.scrollTop = 0; return; }
    requestAnimationFrame(function () {
      body.scrollLeft = Math.max(0, body.scrollWidth * (fx == null ? 0.5 : fx) - body.clientWidth / 2);
      body.scrollTop = Math.max(0, body.scrollHeight * (fy == null ? 0.5 : fy) - body.clientHeight / 2);
    });
  }
  function zoomToggle(e) {
    var img = q('[data-vne-zimg]', zoomEl), r = img.getBoundingClientRect(), fx = null, fy = null;
    if (!P.z && e && r.width && r.height) { fx = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)); fy = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)); }
    zoomSet(!P.z, fx, fy);
    if (P.z) track('photo_zoom_in', { i: P.gal });
  }
  function openZoom(trigger) {
    if (!zoomEl || !PD.slides.length) return;
    pin(trigger);   /* taps on iPhone do not focus buttons, so name the way back */
    remember();
    zoomPaint();
    zoomEl.classList.add('vne-on');
    lock();
    focusIn('[data-vne-zx]');
    track('photo_view', { i: P.gal });
  }
  function closeZoom() {
    if (!zoomEl || !zoomEl.classList.contains('vne-on')) return;
    zoomEl.classList.remove('vne-on');
    zoomSet(false);
    lock();
    restore();
  }
  function pdpPaint() {
    var btn = q('[data-vne-pbuy]'), has = inCart(PD.vid), qs = q('[data-vne-pqtys]');
    if (qs) qs.hidden = has || !PD.avail;
    qa('[data-vne-pqty]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-vne-pqty') === P.qty)); });
    if (!btn) return;
    var others = PD.key ? boxCount() : 0, tot = money(PD.key ? qtyPrice(PD.price, P.qty, others).tot : PD.price * P.qty), u = PD.unit;
    if (PD.key) qa('[data-vne-pqp]').forEach(function (el) { el.innerHTML = qtyPrice(PD.price, +el.getAttribute('data-vne-pqp'), others).html; });
    btn.disabled = !PD.avail && !has;
    btn.classList.toggle('vne-in', has);
    btn.innerHTML = has ? bi('Đã chọn · Xem đơn hàng', 'Added · View order')
      : !PD.avail ? bi('Hết hàng', 'Sold out')
      : P.qty > 1 ? bi(('Mua ' + P.qty + ' ' + u[0]).trim() + ' · ' + tot, ('Buy ' + P.qty + ' ' + u[2]).trim() + ' · ' + tot)
      : bi('Mua ngay · ' + tot, 'Buy now · ' + tot);
  }
  function pdpBuy(via) {
    pin(q('[data-vne-pbuy]'));
    track('buy_click', { id: PD.key || PD.handle, size: PD.large ? 'large' : 'main', qty: P.qty, where: via || 'pdp' });
    if (inCart(PD.vid)) { openDrawer(); return; }
    if (PD.avail) add(PD.vid, P.qty);
  }
  function pdpBar() {
    if (inCart(PD.vid) || PD.avail) pdpBuy('bar');
    else W.location.href = 'tel:' + D.tel;
  }
  function pdpInit() {
    pixel('ViewContent', { content_ids: [String(PD.vid)], content_type: 'product', value: PD.price / 100, currency: D.currency }, true);
    var pf = q('[data-vne-pfacts]');
    if (pf) pf.innerHTML = factsHtml(!PD.nest, !!PD.key && PD.key !== 'island', PD.price, PD.handle);
    pdpGo(0);
    var st = q('[data-vne-pstage]');
    if (st && PD.slides.length > 1) {
      var x0 = 0, y0 = 0, on = false;
      st.addEventListener('touchstart', function (e) { on = e.touches.length === 1; if (on) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; } }, { passive: true });
      st.addEventListener('touchend', function (e) {
        if (!on) return;
        on = false;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) { swiped = Date.now(); pdpGo(P.gal + (dx < 0 ? 1 : -1)); track('photo_swipe', { i: P.gal }); }
      }, { passive: true });
    }
    track('pdp_view', { id: PD.key || PD.handle, price: PD.price / 100, avail: PD.avail });
  }

  /* ---------- one click handler for the whole page ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode;
    var el;
    if ((el = t.closest('button[data-vne-lang]'))) { setLang(el.getAttribute('data-vne-lang')); return; }
    if ((el = t.closest('button[data-vne-size]'))) { setSize(el.getAttribute('data-vne-size')); return; }
    if ((el = t.closest('[data-vne-hcart]')) && drawerRoot && !/\/cart\/?$/.test(location.pathname)) { e.preventDefault(); track('cart_open', { via: 'header' }); openDrawer(); return; }
    if (PD) {
      if ((el = t.closest('[data-vne-pthumb]'))) { pdpGo(+el.getAttribute('data-vne-pthumb')); track('photo_pick', { i: P.gal }); return; }
      if ((el = t.closest('[data-vne-pprev]'))) { pdpGo(P.gal - 1); return; }
      if ((el = t.closest('[data-vne-pnext]'))) { pdpGo(P.gal + 1); return; }
      if ((el = t.closest('[data-vne-pzoom]'))) { if (Date.now() - swiped > 450) openZoom(el); return; }
      if ((el = t.closest('[data-vne-pjump]'))) { pdpGo(+el.getAttribute('data-vne-pjump')); openZoom(el); return; }
      if ((el = t.closest('[data-vne-pqty]'))) { P.qty = +el.getAttribute('data-vne-pqty'); pdpPaint(); paintBar(); track('qty_pick', { id: PD.key || PD.handle, n: P.qty }); return; }
      if ((el = t.closest('[data-vne-pbuy]'))) { pdpBuy(); return; }
      if ((el = t.closest('[data-vne-zclose]'))) { closeZoom(); return; }
      if ((el = t.closest('[data-vne-zprev]'))) { pdpGo(P.gal - 1); return; }
      if ((el = t.closest('[data-vne-znext]'))) { pdpGo(P.gal + 1); return; }
      if ((el = t.closest('[data-vne-zimg]'))) { zoomToggle(e); return; }
    }
    if ((el = t.closest('[data-vne-herocta]'))) { heroGo(el); return; }
    if ((el = t.closest('[data-vne-bargo]'))) { if (PD) pdpBar(); else if (count() > 0) openDrawer(); else heroGo(); return; }
    if ((el = t.closest('[data-vne-tile]'))) { var k = el.getAttribute('data-vne-tile'); track('purpose_pick', { k: k }); setFilter(filter === k ? 'all' : k, filter !== k); return; }
    if ((el = t.closest('[data-vne-seeall]'))) { setFilter('all', false); return; }
    if ((el = t.closest('[data-vne-pickgift]'))) { setFilter('gift', true); return; }
    if ((el = t.closest('[data-vne-add]'))) { quickAdd(el.getAttribute('data-vne-add'), el); return; }
    if ((el = t.closest('[data-vne-open]'))) {
      if (Date.now() - cardSwipeAt < 350) { e.preventDefault(); return; }
      if (el.tagName === 'A') { if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); }
      var oc = el.closest('[data-vne-card]');   /* opened from a card the pointer was scrubbing: start on that photo */
      openSheet(el.getAttribute('data-vne-open'), el.classList.contains('vne-cmp-row') ? 'compare' : 'card', oc && oc._g && oc._g.i ? oc._g.i : 0, !!(oc && oc.getAttribute('data-vne-big') === '1'));
      return;
    }
    if ((el = t.closest('[data-vne-cmptog]'))) { toggleCompare(el); return; }
    if ((el = t.closest('.vne-faq-q'))) { toggleFaq(el); return; }
    if ((el = t.closest('[data-vne-vidtog]'))) { toggleClip(); return; }
    if ((el = t.closest('[data-vne-vidfull]'))) { fullVideo(el); return; }
    if ((el = t.closest('[data-vne-labopen]'))) { openLab(); return; }
    if ((el = t.closest('[data-vne-labclose]'))) { closeLab(); return; }
    /* menu */
    if ((el = t.closest('[data-vne-menuopen]'))) { openMenu(); return; }
    if ((el = t.closest('[data-vne-menuclose]'))) { closeMenu(); return; }
    if ((el = t.closest('[data-vne-menulink]'))) { menuLink(el, e); return; }
    /* sheet */
    if ((el = t.closest('[data-vne-sheetclose]'))) { closeSheet(); return; }
    if ((el = t.closest('[data-vne-gal]'))) { S.gal = +el.getAttribute('data-vne-gal'); renderSheet(); return; }
    if ((el = t.closest('[data-vne-pick-size]'))) { S.big = el.getAttribute('data-vne-pick-size') === '1'; renderSheet(); track('size_pick', { id: S.key, size: S.big ? 'large' : 'main' }); return; }
    if ((el = t.closest('[data-vne-bundleadd]'))) { track('bundle_add', { n: boxCount() + 1 }); change(el.getAttribute('data-vne-bundleadd'), +el.getAttribute('data-q') + 1); return; }
    if ((el = t.closest('[data-vne-qty]'))) { S.qty = +el.getAttribute('data-vne-qty'); renderSheet(); track('qty_pick', { id: S.key, n: S.qty }); return; }
    if ((el = t.closest('[data-vne-buy]'))) { buyFromSheet(); return; }
    /* drawer */
    if ((el = t.closest('[data-vne-toshop]'))) {
      /* home: back to the product grid; product page: down to the other products */
      var to = q('[data-vne-gridhead]') || q('[data-vne-related]');
      closeDrawer();
      if (to) setTimeout(function () { scrollToEl(to, 16); }, 60); else W.location.href = ROOT + '#collection';
      return;
    }
    if ((el = t.closest('[data-vne-drawerclose]'))) { closeDrawer(); return; }
    if ((el = t.closest('[data-vne-inc]'))) { change(el.getAttribute('data-vne-inc'), +el.getAttribute('data-q') + 1); return; }
    if ((el = t.closest('[data-vne-dec]'))) { change(el.getAttribute('data-vne-dec'), Math.max(0, +el.getAttribute('data-q') - 1)); return; }
    if ((el = t.closest('[data-vne-rm]'))) { change(el.getAttribute('data-vne-rm'), 0); return; }
    if ((el = t.closest('[data-vne-checkout]'))) { checkout(e); return; }
    if ((el = t.closest('[data-vne-tocb]'))) { openDrawer(true); track('callback_click', { where: 'drawer' }); return; }
    if ((el = t.closest('[data-vne-cbopen]'))) { openDrawer(true); track('callback_click', { where: 'order' }); return; }
    if ((el = t.closest('[data-vne-pref]'))) { setPref(el.getAttribute('data-vne-pref')); return; }
    if ((el = t.closest('[data-vne-giftchk]'))) {
      var on = el.getAttribute('aria-pressed') !== 'true';
      el.setAttribute('aria-pressed', String(on));
      q('[data-vne-giftnote]').hidden = !on;
      saveGiftSoon();
      track('gift_toggle', { on: on });
      return;
    }
    if ((el = t.closest('[data-vne-vcard]'))) { vcard(); return; }
    if ((el = t.closest('[data-vne-cbedit]'))) { editPhone(); return; }
  });

  /* calls, texts, Zalo and Messenger taps → analytics + Meta "Contact" */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !root.contains(a)) return;
    var h = a.getAttribute('href') || '', kind = h.indexOf('tel:') === 0 ? 'call' : h.indexOf('sms:') === 0 ? 'sms' : h.indexOf('zalo.me') > -1 ? 'zalo' : h.indexOf('m.me') > -1 ? 'messenger' : '';
    if (!kind) return;
    var sec = a.closest('[data-vne-bar]') ? 'bar' : a.closest('[data-vne-sheet]') ? 'sheet' : a.closest('[data-vne-drawer]') ? 'drawer' : a.closest('header') ? 'header' : (a.closest('section,footer') || {}).id || 'footer';
    track(kind + '_click', { where: sec });
    pixel('Contact', { content_name: kind });
  }, true);

  document.addEventListener('keydown', function (e) {
    var k = openKind(), arrow = e.key === 'ArrowLeft' || e.key === 'ArrowRight';
    /* product photos: arrow keys while the photo (or its buttons) has focus, and in the viewer */
    if (PD && !k && arrow) { var a = document.activeElement; if (a && a.closest && a.closest('[data-vne-pgal]')) { e.preventDefault(); pdpGo(P.gal + (e.key === 'ArrowRight' ? 1 : -1)); } return; }
    if (!k) return;
    if (e.key === 'Escape') { e.preventDefault(); if (k === 'zoom') closeZoom(); else if (k === 'lab') closeLab(); else if (k === 'drawer') closeDrawer(); else if (k === 'menu') closeMenu(); else closeSheet(); return; }
    if (k === 'zoom' && arrow && !P.z) { e.preventDefault(); pdpGo(P.gal + (e.key === 'ArrowRight' ? 1 : -1)); return; }
    if (e.key === 'Tab') trap(e);
  });

  /* ---------- start ---------- */
  syncToggles();
  relabel();
  compact();
  if (ANGLE === 'gift' || ANGLE === 'tet') setFilter('gift', false);
  else if (ANGLE === 'daily' || ANGLE === 'best') setFilter(ANGLE, false);
  if (ANGLE !== 'default') track('landing_angle', { angle: ANGLE });

  var phoneIn = q('[data-vne-phone]');
  if (phoneIn) phoneIn.addEventListener('input', function () {
    var v = asYouType(phoneIn.value);
    if (v !== phoneIn.value) phoneIn.value = v;
    if (q('[data-vne-fphone]').classList.contains('vne-err') && digits(v).length === 10) fieldError('phone', false);
  });
  var nameIn = q('[data-vne-name]');
  if (nameIn) nameIn.addEventListener('input', function () { if (nameIn.value.trim()) fieldError('name', false); });
  if (note) note.addEventListener('input', saveGiftSoon);
  if (form) form.addEventListener('submit', submitCb);

  if (IOS) {
    qa('[data-vne-dir]').forEach(function (a) { a.setAttribute('href', 'https://maps.apple.com/?daddr=' + a.getAttribute('data-vne-dir')); });
    qa('[data-vne-map]').forEach(function (a) { a.setAttribute('href', 'https://maps.apple.com/?q=' + a.getAttribute('data-vne-map')); });
  }

  /* vinanest-chat.js re-measures the bar when its class changes; nudge it once the slide has finished */
  if (bar) bar.addEventListener('transitionend', function (e) { if (e.target === bar && e.propertyName === 'transform') bar.classList.toggle('vne-moved'); });
  W.addEventListener('scroll', onScroll, { passive: true });
  var rt = 0;
  W.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { compact(); refit(); }, 120); });
  W.addEventListener('pageshow', function (e) { if (e.persisted) loadCart().catch(function () {}); });

  /* ---------- product cards: every photo of a box on its card ----------
     Desktop: moving the pointer across the photo scrubs through the photos. Touch: swiping the photo sideways steps
     through them; ticks under the photo show how many there are. A tap opens the sheet at the photo shown.
     Photos load only when needed: desktop shortly before a card scrolls into view, touch on the first touch of a card. */
  function cardGal(card, noLoad) {
    if (card._g) { if (!noLoad) galLoad(card._g); return card._g; }
    var p = BY[card.getAttribute('data-vne-card')], box = q('.vne-card-img', card), shots = [];
    if (!p || !box) return null;
    var caps = [], v = variantOf(p, card.getAttribute('data-vne-big') === '1');
    if (v.info) { shots.push(v.info[0]); caps.push(null); }   /* the infographic and the label carry their own titles */
    if (v.scene) { shots.push(v.sceneM || v.scene[0]); caps.push(p.jars ? ['Gợi ý thưởng thức', 'Serving suggestion'] : ['Gợi ý cách dùng', 'Serving suggestion']); }
    var fit = -1;   /* the label is shown whole (contain), photos fill the square */
    if (v.label) { fit = shots.length; shots.push(v.label[0]); caps.push(null); }
    if (!shots.length) return (card._g = { n: 1 });
    var wrap = document.createElement('span');
    wrap.className = 'vne-cg';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = shots.map(function (u, k) { return '<img data-src="' + esc(u) + '"' + (k === fit ? ' class="vne-cg-fit"' : '') + ' alt="" decoding="async">'; }).join('') +
      '<span class="vne-cg-cap" hidden></span><span class="vne-cg-ticks"><i class="vne-on"></i>' + new Array(shots.length + 1).join('<i></i>') + '</span>';
    box.appendChild(wrap);
    card._g = { n: shots.length + 1, i: 0, wrap: wrap, imgs: qa('img', wrap), ticks: qa('i', wrap), cap: q('.vne-cg-cap', wrap), caps: caps, key: p.key, seen: {} };
    if (!noLoad) galLoad(card._g);
    return card._g;
  }
  function galLoad(g) {
    if (!g.imgs || g.loaded) return;
    g.loaded = true;
    g.imgs.forEach(function (im) { if (!im.getAttribute('src')) im.setAttribute('src', im.getAttribute('data-src')); });
  }
  function cardShow(card, i, dir) {
    var g = card._g;
    if (!g || g.n < 2 || g.i === i) return;
    g.i = i;
    if (dir) g.wrap.setAttribute('data-dir', dir); else g.wrap.removeAttribute('data-dir');
    g.imgs.forEach(function (im, k) { im.classList.toggle('vne-on', k === i - 1); });
    g.ticks.forEach(function (t, k) { t.classList.toggle('vne-on', k === i); });
    var cc = i ? g.caps[i - 1] : null;
    g.cap.hidden = !cc;
    if (cc) g.cap.innerHTML = bi(cc[0], cc[1]);
    if (i && !g.seen[i]) { g.seen[i] = 1; track('card_frame', { id: g.key, i: i }); }
  }
  /* touch: ticks on every card from the start (no photos loaded), so people can see there is more to swipe */
  function touchTicks() { if (!FINE) qa('[data-vne-card]').forEach(function (c) { cardGal(c, true); }); }
  if (FINE) {
    /* load each card's other photos shortly before it scrolls into view, so the first scrub is instant */
    if ('IntersectionObserver' in W) {
      var cio = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { cardGal(en.target); cio.unobserve(en.target); } }); }, { rootMargin: '200px 0px' });
      qa('[data-vne-card]').forEach(function (c) { cio.observe(c); });
    }
    root.addEventListener('pointerover', function (e) {
      var card = e.pointerType === 'mouse' && e.target.closest && e.target.closest('[data-vne-card]');
      if (card) cardGal(card);
    });
    root.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var box = e.target.closest && e.target.closest('.vne-card-img'), card = box && box.closest('[data-vne-card]'), g = card && cardGal(card);
      if (!g || g.n < 2) return;
      var r = box.getBoundingClientRect();
      cardShow(card, Math.min(g.n - 1, Math.max(0, Math.floor((e.clientX - r.left) / r.width * g.n))));
    });
    root.addEventListener('pointerout', function (e) {
      var box = e.target.closest && e.target.closest('.vne-card-img');
      if (!box || (e.relatedTarget && box.contains(e.relatedTarget))) return;
      var card = box.closest('[data-vne-card]');
      if (card) cardShow(card, 0);
    });
  } else {
    touchTicks();
    /* a sideways swipe on the photo steps one photo (no wrap-around); vertical drags still scroll the page (touch-action: pan-y) */
    var sw = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      var box = e.target.closest && e.target.closest('.vne-card-img'), card = box && box.closest('[data-vne-card]'), g = card && cardGal(card);
      sw = g && g.n > 1 ? { card: card, x: e.clientX, y: e.clientY } : null;
    }, { passive: true });
    root.addEventListener('pointermove', function (e) {
      if (!sw) return;
      var dx = e.clientX - sw.x, dy = e.clientY - sw.y;
      if (Math.abs(dx) < 32 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var g = sw.card._g, to = Math.max(0, Math.min(g.n - 1, g.i + (dx < 0 ? 1 : -1)));
      cardShow(sw.card, to, dx < 0 ? 'next' : 'prev');
      cardSwipeAt = Date.now();
      sw = null;
    }, { passive: true });
    root.addEventListener('pointerup', function () { sw = null; });
    root.addEventListener('pointercancel', function () { sw = null; });
    /* once per visit: the first card shows its second photo for a moment, so the swipe is discoverable */
    var hintDone = false;
    try { hintDone = !!sessionStorage.getItem('vne_cghint'); } catch (e) {}
    var lowData = !!(navigator.connection && navigator.connection.saveData);
    if (!hintDone && !REDUCE && !lowData && 'IntersectionObserver' in W) {
      var first = qa('[data-vne-card]').filter(function (c) { return c.offsetParent !== null; })[0];
      if (first) {
        var hio = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return;
          hio.disconnect();
          try { sessionStorage.setItem('vne_cghint', '1'); } catch (e) {}
          var g = cardGal(first), im = g && g.imgs && g.imgs[0];
          if (!g || g.n < 2 || !im) return;
          var go = function () { if (g.i !== 0) return; cardShow(first, 1, 'next'); setTimeout(function () { if (g.i === 1 && Date.now() - cardSwipeAt > 900) cardShow(first, 0, 'prev'); }, 900); };
          if (im.complete && im.naturalWidth) setTimeout(go, 400); else im.addEventListener('load', function () { setTimeout(go, 400); }, { once: true });
        }, { threshold: 0.6 });
        hio.observe(first);
      }
    }
  }

  /* small API for the page sections that ride on this script (collection grid, cart page, contact and wholesale forms) */
  W.VNE = { add: add, change: change, checkout: checkout, openDrawer: openDrawer, closeDrawer: closeDrawer, loadCart: loadCart, cart: function () { return cart; }, count: count,
    lineName: lineName, lineImg: lineImg, lineSize: lineSize, isAddon: isAddon, money: money, bi: bi, esc: esc, track: track, pixel: pixel, root: ROOT, base: base, data: D, by: BY, byVid: BYVID,
    eta: eta, bundlePct: bundlePct, boxCount: boxCount, giftProp: GIFT_PROP,
    lang: function () { return H.getAttribute('data-vne-lang') || 'vi'; } };
  try { document.dispatchEvent(new CustomEvent('vne:ready')); } catch (e) {}

  if (PD) pdpInit();
  paintStatus();
  setInterval(paintStatus, 60000);
  setupVideo();
  paintBar();
  checkBar();
  refit();

  var posted = q('[data-vne-cbposted]');
  loadCart().catch(function () { setCart(null); }).then(function () {
    if (!posted) return;
    if (posted.getAttribute('data-vne-cbposted') === 'true') {
      var info = {}; try { info = JSON.parse(sessionStorage.getItem('vne_cb') || '{}'); } catch (x) {}
      showDone(info);
      openDrawer();
      try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '')); } catch (x) {}
    } else if (posted.getAttribute('data-vne-cberrors') === 'true') {
      openDrawer(true);
    }
  });
  }
  boot();
  /* theme editor: a settings change re-renders the section, so wire up the new markup */
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('#vne')) boot(); });
})();
